<!--
 * @Descripttion: 历史流程
 * @Author: jschen
 * @Date: 2021-09-05 14:28:12
 * @LastEditors: liaoyijun
 * @LastEditTime: 2022-03-23 15:42:47
-->
<template>
    <div v-show="visible" class="right-box">
        <div class="search-container">
            <div class="search-row">
                <div class="title-item">
                    <span>标题</span>
                    <el-input
                        v-model="searchHistoryOpt.title"
                        placeholder="标题关键字搜索"
                        prefix-icon="el-icon-search"
                        size="small"
                    >
                    </el-input>
                </div>
                <div class="date-item">
                    <span>创建时间</span>
                    <div class="block">
                        <el-date-picker
                            v-model="searchHistoryOpt.date"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            size="small"
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            @change="datePicker"
                        >
                        </el-date-picker>
                    </div>
                </div>
                <!-- <div class="creator-item">
                    <el-input
                        v-model="searchHistoryOpt.creatorName"
                        placeholder="发起人搜索"
                        prefix-icon="el-icon-search"
                        size="small"
                    ></el-input>
                </div> -->
                <div class="search-btn-group">
                    <el-button type="primary" size="small" @click="search">查询</el-button>
                    <el-button size="small" @click="reset">重置</el-button>
                </div>
            </div>
        </div>
        <div class="sort-box">
            <div class="sort-title">
                <span
                    >{{ title }}列表<span style="color: #999;padding-left: 5px;">{{ title1 }}</span></span
                >
            </div>
            <div class="search-right-box">
                <div class="sort-right-box">
                    <el-button plain size="mini" @click="refresh">刷新</el-button>
                </div>
            </div>
        </div>
        <el-table
            v-loading="loading"
            :data="appRecords"
            size="mini"
            border
            style="width: 100%"
            height="calc(100% - 145px)"
            tooltip-effect="dark"
            @row-click="rowHistoryClick"
        >
            <el-table-column label="序号" width="55" align="center">
                <template slot-scope="scope">{{ scope.$index + 1 }}</template>
            </el-table-column>
            <el-table-column prop="title" label="标题" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span> {{ scope.row.title }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="creatorname" label="发起人" align="center" width="100"> </el-table-column>
            <el-table-column prop="procstatus" label="流程状态" align="center" width="100">
                <template slot-scope="scope">
                    <span class="process-color">{{ scope.row.procstatus }}</span>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="procstatus" label="审核状态" align="center" width="100">
                <template slot-scope="scope">
                    <span class="process-color">{{ scope.row.procstatus }}</span>
                </template>
            </el-table-column> -->
            <el-table-column prop="createTime" sortable label="创建时间" width="150" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.createTime | dateFilter }}</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="finishTime"
                sortable
                label="结束时间"
                :show-overflow-tooltip="true"
                width="150"
                align="center"
            >
                <template slot-scope="scope">
                    <span>{{ scope.row.finishTime }}</span>
                </template>
            </el-table-column>
            <div slot="append" style="width:100%;height:30px;"></div>

            <div slot="empty" class="empty">
                <img src="@/assets/pics/no-empty.png" />
                <span>暂无内容</span>
            </div>
        </el-table>
        <div class="pagination-box">
            <el-pagination
                :current-page="searchHistoryOpt.current"
                :page-sizes="[20, 50]"
                :page-size="searchHistoryOpt.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchHistoryOpt.total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import { historyTasks } from "@/api";
import _ from "lodash";
export default {
    props: {
        title: {
            type: String,
            default: "",
        },
        title1: {
            type: String,
            default: "",
        },
        visible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            appRecords: [],
            multipleSelection: [],
            searchHistoryOpt: {
                title: "",
                date: "",
                startDate: "",
                endDate: "",
                current: 1,
                size: 20,
                total: 0,
            },
        };
    },
    computed: {
        levelStatus() {
            return function(status) {
                let level = parseInt(status);
                let levelName = "正常";
                switch (level) {
                    case 1:
                        levelName = "紧急";
                        break;
                    case 2:
                        levelName = "重要";
                        break;
                    default:
                        levelName = "正常";
                        break;
                }
                return levelName;
            };
        },
        levelStyle() {
            return function(level) {
                return `level${level}`;
            };
        },
    },
    methods: {
        search() {
            this.searchHistoryOpt.current = 1;
            this.loadData();
        },
        loadData() {
            this.queryHistoryList();
        },
        changeSearchOps(item) {
            this.searchHistoryOpt = {
                ...this.searchHistoryOpt,
                ...item,
            };
        },
        // 查询审批列表
        async queryHistoryList() {
            this.loading = true;
            try {
                const { body, code, message } = await historyTasks({
                    ..._.omit(this.searchHistoryOpt, ["date", "total"]),
                });
                if (code === "0000") {
                    const { current, records, total } = body;
                    this.appRecords = records;
                    this.searchHistoryOpt.total = total;
                    this.searchHistoryOpt.current = current;
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                console.error(err);
            }
            this.loading = false;
        },
        batchCheck() {
            this.$emit("check");
        },
        // 置为已读
        setRead() {},
        // 刷新
        refresh() {
            this.reset();
        },
        clearKw() {
            this.searchHistoryOpt = {
                creatorName: "",
                title: "",
                alarmLevel: null,
                date: "",
                startDate: "",
                endDate: "",
                taskType: 0,
                handleType: 0,
                handleGroup: "All",
                current: 1,
                size: 20,
                total: 0,
            };
        },
        reset() {
            this.searchHistoryOpt = {
                creatorName: "",
                title: "",
                alarmLevel: null,
                date: "",
                startDate: "",
                endDate: "",
                taskType: 0,
                handleType: 0,
                handleGroup: "All",
                current: 1,
                size: 20,
                total: 0,
            };
            this.loadData();
        },
        datePicker(dateArr) {
            const [startDate, endDate] = dateArr;
            this.searchHistoryOpt.startDate = startDate ? `${startDate} 00:00:00` : "";
            this.searchHistoryOpt.endDate = endDate ? `${endDate} 23:59:59` : "";
        },
        rowHistoryClick({ url }) {
            window.open(url);
        },
        handleSizeChange(val) {
            this.searchHistoryOpt.current = 1;
            this.searchHistoryOpt.size = val;
            this.loadData();
        },
        handleCurrentChange(val) {
            this.searchHistoryOpt.current = val;
            this.loadData();
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../style.scss";
.search-row {
    align-items: center;
    span {
        margin-right: 8px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
    }
}
</style>
